/* IIG London: sign-up pop-up. Opens once per visit (or once every few days
   when "days" is set) after a delay or part-way down the page; never again
   after a sign-up; after a sign-up the page reloads and the pop-up reopens
   on the discount code. */
(function () {
  if (customElements.get('iig-popup')) return;

  const UNTIL = 'iig-popup-until';
  const SENT = 'iig-popup-sent';
  const SEEN = 'iig-popup-seen';
  const DAY = 86400000;

  function read(store, key) {
    try { return store.getItem(key); } catch (e) { return null; }
  }

  function write(store, key, value) {
    try { store.setItem(key, value); } catch (e) { /* storage blocked */ }
  }

  function remove(store, key) {
    try { store.removeItem(key); } catch (e) { /* storage blocked */ }
  }

  class IIGPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

      this.signup = this.querySelector('[data-signup]');
      this.success = this.querySelector('[data-success]');
      const days = Number(this.dataset.days);
      this.days = Number.isFinite(days) && days >= 0 ? days : 0;

      this.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', () => this.close()));
      this.dialog.addEventListener('cancel', () => this.snooze());
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.close();
      });

      const form = this.querySelector('form');
      if (form) {
        form.addEventListener('submit', () => {
          write(sessionStorage, SENT, '1');
          write(localStorage, UNTIL, String(Date.now() + 365 * DAY));
        });
      }

      const copy = this.querySelector('[data-copy]');
      if (copy) copy.addEventListener('click', () => this.copyCode(copy));

      const posted = this.querySelector('[data-posted]');
      const error = this.querySelector('[data-error]');
      const sent = read(sessionStorage, SENT) === '1';

      const urlPosted = /[?&]customer_posted=true/.test(window.location.search);
      if (posted && (sent || urlPosted)) {
        remove(sessionStorage, SENT);
        write(localStorage, UNTIL, String(Date.now() + 365 * DAY));
        this.showSuccess();
        this.open();
        return;
      }
      if (sent && error) {
        remove(sessionStorage, SENT);
        this.open();
        return;
      }

      // Sign-ups block it for a year. A shorter block is a close from when the
      // pop-up waited days between showings; with days at 0 it no longer counts.
      const until = Number(read(localStorage, UNTIL) || 0);
      const left = until - Date.now();
      if (left > 0 && (this.days || left > 30 * DAY)) return;
      if (read(sessionStorage, SEEN) === '1') return;

      this.arm();
    }

    arm() {
      const delay = Number(this.dataset.delay) || 8000;
      const share = (Number(this.dataset.scroll) || 50) / 100;
      const trigger = () => {
        clearTimeout(this.timer);
        window.removeEventListener('scroll', onScroll);
        this.open();
      };
      const onScroll = () => {
        const max = document.documentElement.scrollHeight - window.innerHeight;
        if (max > 0 && window.scrollY / max >= share) trigger();
      };
      this.timer = setTimeout(trigger, delay);
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    open() {
      if (this.dialog.open) return;
      if (document.querySelector('dialog[open]:not(.iig-popup__dialog)')) return;
      write(sessionStorage, SEEN, '1');
      this.dialog.showModal();
    }

    close() {
      this.snooze();
      this.dialog.close();
    }

    snooze() {
      write(sessionStorage, SEEN, '1');
      if (!this.days) return;
      const until = Number(read(localStorage, UNTIL) || 0);
      const next = Date.now() + this.days * DAY;
      if (next > until) write(localStorage, UNTIL, String(next));
    }

    showSuccess() {
      if (this.signup) this.signup.hidden = true;
      if (this.success) this.success.hidden = false;
      const title = this.success && this.success.querySelector('h2');
      if (title) {
        title.id = 'IIGPopupTitle';
        const old = this.signup && this.signup.querySelector('h2');
        if (old) old.removeAttribute('id');
      }
    }

    copyCode(button) {
      const code = this.querySelector('[data-code]');
      if (!code) return;
      const text = code.textContent.trim();
      const done = () => {
        button.textContent = 'Copied';
        setTimeout(() => { button.textContent = 'Copy'; }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(() => this.selectCode(code));
      } else {
        this.selectCode(code);
      }
    }

    selectCode(code) {
      const range = document.createRange();
      range.selectNodeContents(code);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    }
  }

  customElements.define('iig-popup', IIGPopup);
})();
